module.exports = __webpack_public_path__ + "static/media/tiradentes-mg.01753845.jpg";